module.exports = __webpack_public_path__ + "img/ty-qrCode.3ca637eb.png";